import * as i0 from '@angular/core';
import { Component, NgModule } from '@angular/core';

/**
 * Icon Component
 *
 * @description An easy way to use icons supported in the roosevelt-icon font. To control the color or the size use font-size and color styles.
 * @example
 * <!-- rs-doc {link: 'single icon example'} -->
 * <rs-icon>alert</rs-icon>
 * <rs-icon style="font-size: 48px">alert</rs-icon>
 * <rs-icon style="color: red; font-size: 72px">alert</rs-icon>
 * @example
 * <!-- rs-doc {link: 'all icons', data: { icons: [], ngOnInit: function(){ setTimeout(() => this.icons = window.icons, 100); } }} -->
 * <div style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap;">
 *  <div style="text-align: center; flex: 1 0 25%; padding: 15px 0" *ngFor="let icon of icons">
 *   <rs-icon style="font-size: 32px">{{icon}}</rs-icon>
 *   <p>{{icon}}</p>
 *  </div>
 * </div>
 *
 */
class IconComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: IconComponent, isStandalone: true, selector: "rs-icon", host: { classAttribute: "roosevelt-icon" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'rs-icon',
                    template: '<ng-content></ng-content>',
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        class: 'roosevelt-icon'
                    },
                    standalone: true
                }]
        }] });

class IconModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: IconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: IconModule, imports: [IconComponent], exports: [IconComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: IconModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        IconComponent
                    ],
                    exports: [
                        IconComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { IconComponent, IconModule };
